module.exports = __webpack_public_path__ + "static/media/PC_Carrosel_BIG_DATA_E_DATA_MINING.75d45c2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/bigData_Mining/PC_Carrosel_BIG_DATA_E_DATA_MINING.png
// module id = 199
// module chunks = 0